import React, { memo, useState, useContext } from "react";
import { Button, Modal, Form, Card, Col, Row, Spinner } from "react-bootstrap";
import { useSelector, useDispatch } from 'react-redux';
import { closeModal, updateData } from "slices/stillageCollections";
import FalconCloseButton from "components/common/FalconCloseButton";
import classNames from "classnames";
import Flex from "components/common/Flex";
import { updateStillageCollection } from "services/stillageCollections";
import { toast } from "react-toastify";
import { StillageCollectionDataContext } from "context/Context";

const MarkAsCollected = () => {
    const [selected, setSelected] = useState([]);
    const [loading, setLoading] = useState(false);
    const { markCollected: { show, data: { collectionNote, stillagesToFit } } } = useSelector(state => state.stillageCollections);
    const { data, setData } = useContext(StillageCollectionDataContext);
    const dispatch = useDispatch();
    const collectionDate = data?.tableData?.find(x => x.collectionNote === collectionNote)?.collectionDate;

    const removeStillage = (state, no) => {
        let stills = [...state];
        stills.splice(state.indexOf(no), 1);
        return stills;
    }

    const handleClick = async () => {
        setLoading(true);
        try {
            const res = await updateStillageCollection(collectionNote, collectionDate, selected, "collected");

            if (res?.success) {
                // Update table data to colour row
                const newData = [...data.tableData];
                newData.find(x => x.collectionNote == collectionNote).collectedData.push(
                    ...selected.map(y => {
                        return {
                            stillageNo: y, collectedDate: collectionDate, collectedScannerNotes: 'return_to_emplas'
                        }
                    })
                );
                setData({ ...data, tableData: newData });
                // Update modal data to remove collected stillages
                dispatch(updateData({
                    key: 'markCollected',
                    data: {
                        collectionNote, stillagesToFit: [...stillagesToFit.filter(x => !selected.some(y => y == x))]
                    }
                }));

                toast.success(`Stillage(s) successfully updated to collected! `, res?.message || '');
            }
            else
                toast.error('There was a problem updating the stillages! Please try again. ', res?.message || '');
        } catch (err) {
            toast.error('Something went wrong! ', err.message);
            console.error(err);
        } finally {
            setLoading(false);
            setSelected([]);
        }
    }

    return (
        <Modal show={show}>
            <Modal.Header>
                <Modal.Title>Mark A Stillage As Collected - <span className="d-block">{collectionNote}</span></Modal.Title>
                <FalconCloseButton onClick={() => dispatch(closeModal())} /></Modal.Header>
            <Modal.Body>
                <p className="mb-3 p-2">Select stillage(s) from the list below and press confirm to mark them as collected.</p>
                <Row>
                    {stillagesToFit ?
                        stillagesToFit?.map(x => (
                            <Col key={x} xs={3}>
                                <Card
                                    className={classNames('mb-3 p-2 cursor-pointer user-select-none', {
                                        'bg-success': selected.includes(x), 'text-light': selected.includes(x)
                                    })}
                                    onClick={() =>
                                        !loading ?
                                            (selected.includes(x)) ?
                                                setSelected(prev => removeStillage(prev, x)) :
                                                setSelected(prev => [...prev, x]) :
                                            null
                                    }>
                                    <Flex justifyContent='between'>
                                        <Form.Check
                                            checked={selected.includes(x)}
                                            isValid
                                            type='checkbox'
                                            id={`chbx_${x}`}
                                            onChange={e =>
                                                !loading ?
                                                    (e.target.checked ?
                                                        setSelected(prev => [...prev, x]) :
                                                        setSelected(prev => removeStillage(prev, x))) :
                                                    null
                                            }
                                        />
                                        <div>{x}</div>
                                    </Flex>
                                </Card>
                            </Col>
                        )) :
                        <Col xs={12} className="text-center">All stillages fitted 😊</Col>
                    }
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loading}
                    onClick={handleClick}>
                    Confirm {loading && <span><Spinner size="sm" variant="light" /></span>}</Button>
                <Button
                    variant="secondary"
                    onClick={() => dispatch(closeModal())}
                    disabled={loading}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default memo(MarkAsCollected);